import React from 'react';
import { ICategoryDesc } from '../../types/customizer';
import CustomEditor from '../CustomEditor';
import If from '../If';

interface IMaterialInfo extends ICategoryDesc {
  onBack?: () => void;
}

const MaterialInfo = ({ name, short_desc, link, image_url, properties, video_url, disclaimer }: IMaterialInfo) => {
  return (
    <div className="material-info-container">
      <div className="tw-flex tw-flex-col tw-order-2 material-info-left">
        <div className="tw-flex-1 tw-border tw-border-solid tw-border-[#D5D5D5] tw-rounded tw-p-4">
          <div className="tw-text-xl tw-mb-2 primary-font-family">{name}</div>
          <CustomEditor source={short_desc} readOnly={true} />
          {link ? (
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              data-name={name}
              className="tw-text-sm tw-text-primary-color tw-mt-4 tw-mb-1.5 tw-inline-block tw-border-b tw-border-solid tw-border-primary-color learn-more-modal"
            >
              learn more &rarr;
            </a>
          ) : null}
        </div>
        <If condition={!!disclaimer}>
          <p className="tw-text-sm tw-text-amber-600 tw-mt-2">
            <span className="tw-font-semibold">Disclaimer:</span> {disclaimer}
          </p>
        </If>
      </div>
      <div className="tw-pt-0 tw-order-1 modal-media-wrapper">
        <If condition={video_url}>
          <video src={video_url} autoPlay={true} loop={true} muted={true} playsInline={true} className="modal-media" />
        </If>
        <If condition={image_url && !video_url}>
          <img className="modal-media" src={image_url} alt="Mountain" />
        </If>
      </div>
    </div>
  );
};

export default MaterialInfo;
